
<template>
    
  <div class="wrapper-portafolio padding2">
    <div class="layout-1">
      <div class="wrapper-desplegables "  >
        <div class="movil-seleccione"  @click="disenio()" ref="myDiv" >Seleccione</div>
        <div class="section1 desplegable-opciones  menuopciones" ref="desplegable">
          
          <div class="section">
            <div
              class="general"
              :class="{
                selected: selectedOpt === tipoDireccion
              }"
              @click="setSelectedOpt(tipoDireccion), ocultarblock() "
              v-for="(tipoDireccion, index) of categorias"
              :key="index"
              :id="tipoDireccion"
            >
              {{ tipoDireccion }}
            </div>
          </div>
        </div>
        <div class="section2 desplegable-contenido">
       <h2 class=" titulorecursos"> {{selectedOpt}}</h2>
        <h2 class="desplegable-title subtitle"> Categorías</h2>
        <div class=" desplegable-opciones categorias">
        
            <div
                 class="general"
               :class="{
                selected: selectedSer === filter_categoria[index],
              }"
              @click="setSelectedSer(filter_categoria[index]); "
              v-for="(career, index) of filter_categoria"
              :key="index"
              :id="career"              
            >
            {{career}}
    
            </div>
            </div>
          <h2 class="desplegable-title subtitle">{{text_aux_recursos}}</h2>
          
          <div class="grado section desplegable-contenido">
          
            <div
                class="recurso"
              :class="{
                selected: selectedSer === career.fields.Categor_x00ed_a,
              }"
              v-for="(career, index) of filter_aux_recursos"
              :key="index"
              :id="career.fields.Categor_x00ed_a"
              :track-by="career.fields.Categor_x00ed_a"
            >
         
               <details>
                <summary>
                  <div
                    class="recursos-div"
                    v-html="career.fields.Nombrerecursos"
                    :id="career.fields.Nombrerecursos"
                    @click="setSelectedDServ(career.fields.Nombrerecursos)"
                  ></div>
                  <div class="details-modal-overlay"></div>
                </summary>
                <div
                  class="details-modal"
                  v-for="(tservicio, index) of filter_aux_recursos"
                  :key="index"
                  :style="{
                    display:
                      selectedDServ === tservicio.fields.Nombrerecursos
                        ? 'flex'
                        : 'none',
                  }"
                >
                  <button type="button" class="close " data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                 </button>

                  <div class="details-modal-title">
                    <h1>
                      <div  v-html="tservicio.fields.Nombrerecursos"></div>
                      <div
                        class="title-tab"
                        v-html="tservicio.fields.Periodo"
                      ></div>
                    </h1>
                  </div>
                  
                  <div class="details-modal-content">
                  <b>Descripción</b>
                  <br>
                    
                    <div v-html="tservicio.fields.Descripci_x00f3_ndelrecurso"></div>
                    <!--  <iframe width="100%" height="315" :src="tservicio.fields.EnlaceRecurso.Url" frameborder="0" allowfullscreen></iframe>-->
                    <div v-if="tservicio.fields.Tipoderecurso=='Youtube'">
                       <embed :src="tservicio.fields.EnlaceRecurso.Url" width="100%" height="385" >
                    
                    </div>

                  </div>
                </div>
              </details>
            </div>
          </div>
       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from 'lodash';


const restservicios =
  "https://srv-si-001.utpl.edu.ec/apim/graph/1.0/sites/utpl.sharepoint.com,8222b2b5-7baa-4832-886a-ddb9add3ab4e,415e85dd-1e9d-4ace-980e-51f6c2e371a0/lists/8ffbbd34-8d03-4e46-83e6-749d0a39f829?select=id&expand=columns(select=name,choice),items(expand=fields(select=choice,Descripci_x00f3_ndelrecurso,Periodo,Nombrerecursos,Direcci_x00f3_n,Estado,EnlaceRecurso,SubCategoria) ";
const config = {
  headers: {
    apikey:
      "eyJ4NXQiOiJOVGRtWmpNNFpEazNOalkwWXpjNU1tWm1PRGd3TVRFM01XWXdOREU1TVdSbFpEZzROemM0WkE9PSIsImtpZCI6ImdhdGV3YXlfY2VydGlmaWNhdGVfYWxpYXMiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJVVFBMLkVEVS5FQ1wvYWNjYXJkZW5hczRAY2FyYm9uLnN1cGVyIiwiYXBwbGljYXRpb24iOnsib3duZXIiOiJVVFBMLkVEVS5FQ1wvYWNjYXJkZW5hczQiLCJ0aWVyUXVvdGFUeXBlIjpudWxsLCJ0aWVyIjoiVW5saW1pdGVkIiwibmFtZSI6IlBvcnRhbGVzV2ViIiwiaWQiOjY2MSwidXVpZCI6ImE3NjY3NDJiLTgxMzktNGZlZC1hNGI4LTEzNTA3NGM5YWZjYSJ9LCJpc3MiOiJodHRwczpcL1wvc3J2LXNpLTAwMS51dHBsLmVkdS5lYzo0NDNcL29hdXRoMlwvdG9rZW4iLCJ0aWVySW5mbyI6eyJVbmxpbWl0ZWQiOnsidGllclF1b3RhVHlwZSI6InJlcXVlc3RDb3VudCIsImdyYXBoUUxNYXhDb21wbGV4aXR5IjowLCJncmFwaFFMTWF4RGVwdGgiOjAsInN0b3BPblF1b3RhUmVhY2giOnRydWUsInNwaWtlQXJyZXN0TGltaXQiOjAsInNwaWtlQXJyZXN0VW5pdCI6bnVsbH19LCJrZXl0eXBlIjoiUFJPRFVDVElPTiIsInBlcm1pdHRlZFJlZmVyZXIiOiIiLCJzdWJzY3JpYmVkQVBJcyI6W3sic3Vic2NyaWJlclRlbmFudERvbWFpbiI6ImNhcmJvbi5zdXBlciIsIm5hbWUiOiJQb3J0YWxBcGkiLCJjb250ZXh0IjoiXC9hcGltXC9wb3J0YWx3ZWIiLCJwdWJsaXNoZXIiOiJVVFBMLkVEVS5FQ1wvanNjYWxkZXJvbiIsInZlcnNpb24iOiIxLjAuMCIsInN1YnNjcmlwdGlvblRpZXIiOiJVbmxpbWl0ZWQifSx7InN1YnNjcmliZXJUZW5hbnREb21haW4iOiJjYXJib24uc3VwZXIiLCJuYW1lIjoiR3JhcGhBcGkiLCJjb250ZXh0IjoiXC9hcGltXC9ncmFwaFwvMS4wIiwicHVibGlzaGVyIjoiVVRQTC5FRFUuRUNcL2pzY2FsZGVyb24iLCJ2ZXJzaW9uIjoiMS4wIiwic3Vic2NyaXB0aW9uVGllciI6IlVubGltaXRlZCJ9XSwicGVybWl0dGVkSVAiOiIiLCJpYXQiOjE2NDc4OTg1NDUsImp0aSI6ImFjZjEwZTRmLTQ4ZWUtNGRiMC1iZDNhLWI3OTVhZTc1MWU2YiJ9.CDRJuGgE0cPchL0ldMvJm6CqGQ_X6_c33G2OAkwQ6bBUfuBVJeMxyegF0vh5i6MFEkwYHbFziCNyo7Xp3Hay9GJ2LNimSY3SaUSxxWFwRrgfw77kOVvxUF9LbNtbSXZmKScLmI3fw9qhhOpEWWOYJTJQpH9sfzXJMfhYewfXy9ys1Gi0nH21G5DRp_O43iQAKJrCSXObxuB8otM5Go7h1813neO1IPOwieprUKVxFHR9YQGdaQk5HYIXL_y-SO1_v9ID6kUh2ts1z1grMPPm3KMlcED5yKfHNJl1XIOG0kpvF7bN5ljZRL6QNcr0X9G-MNNETWuA2mWdfh9rF1yK7A==",
  },
};
export default {
  name: "academic-services",
  data() {
    return {
      servicios: [],
      direcciones: [],
      columns: [],
      columnscategory:[],
      categorias: [],
      auxcategorias: [],
      subcategory:[],
      selectedOpt: "Asesoría",
      selectedSer: "",
      selectedDServ: "todo",
      selcategoria:"categoria",
       filter_categoria: [],
       filter_aux_categoria: [],

        filter_recursos: [],
       filter_aux_recursos: [],
       filter_recursos_all: [],
       text_aux_recursos:"",

      cat:[],
      arrays:[],
      
    };
  },
  methods: {
    myEventHandler(e) {
      this.ancho=e.target.innerWidth;
  
  },
  disenio(){
   
    if(this.ancho<600){
      var claseblock=this.$refs.desplegable.outerHTML;
      if( claseblock.search('none')!="-1"){
        this.$refs.desplegable.style.display="block"
      }else{
        this.$refs.desplegable.style.display="none"
      }
    }

  },
   ocultarblock(){
    var anchoinicial=window.innerWidth
     if(anchoinicial<600 ){
      this.$refs.desplegable.style.display="none";  
  }
},
    getServices() {
      axios.get(restservicios, config).then((response) => {
        this.servicios = response.data.items.sort();
        
        this.columns = response.data.columns;


        //Obtengo  las categorías  de cada recurso
        this.columns.forEach((obj) => {
          if (obj.name == "Categor_x00ed_a") {
            this.auxcategorias = obj.choice.choices;
          
          }
        });

        this.auxcategorias = this.auxcategorias.sort(
       );
      this.auxcategorias.forEach((objs) => {
          this.categorias.push(objs.replace(/[0-9][-]/g, ''))
      }
      );
       
        //Obtengo las direcciones 
        this.columns.forEach((obj) => {
          if (obj.name == "Direcci_x00f3_n") {
            this.direcciones = obj.choice.choices;
           
          }
        });
         //Obtengo las subcategorias 
        this.columns.forEach((obj) => {
          if (obj.name == "SubCategoria") {
            this.subcategory = obj.choice.choices;
          }
        });
       this.setSelectedOpt("", this.servicios);
       this.setSelectedSer("", this.servicios);
      });
    },
    mostrar(){
      if (window.innerWidth < 700) {
      document.getElementsByClassName('desplegable-opciones')[0].style.display = "block";
      }
    },
    ocultar(){
      if (window.innerWidth < 700) {
        document.getElementsByClassName('desplegable-opciones')[0].style.display = "none";

      }
      
    },
    setSelectedOpt(option) {
      this.selectedOpt = option;
      this.filter_aux_recursos="";
      this.text_aux_recursos="";
      if (this.selectedOpt == null || this.selectedOpt == "") {
        this.selectedOpt = "Organización de la MAD";
      }

      this.filter_aux_categoria = this.servicios.filter((servicios) =>
        servicios.fields.Categor_x00ed_a.includes(this.selectedOpt)
      );

      this.filter_categoria = this.filter_aux_categoria
        .map((item) => item.fields.SubCategoria)
        .filter((value, index, self) => self.indexOf(value) === index)

     
    },
    setSelectedSer(option) {
      this.selectedSer = option;
      

      if (this.selectedSer == null || this.selectedSer == "") {
        this.selectedSer = "Organización";
      }
        this.text_aux_recursos="Recursos"
        this.filter_aux_recursos = this.servicios.filter((servicios) =>
        servicios.fields.SubCategoria.includes(this.selectedSer));
        

         this.filter_aux_recursos = this.filter_aux_recursos.filter((servicios) =>
        servicios.fields.Estado.includes("Activo"));

       console.log(this.filter_aux_recursos)
   
     

      this.filter_aux_recursos= _.orderBy(this.filter_aux_recursos, ['fields.OrdenRecursos'],['asc']);
    },
    setSelectedDServ(option) {
      this.selectedDServ = option;
    },
    filtro(option){
       this.selcategoria = option;
    

    },

  },
  created() {
    this.getServices();
        window.addEventListener("resize", this.myEventHandler);

  },
  beforemounted() {
    this.setSelectedOpt();
    this.setSelectedSer();
  },
};
</script>
<style>
@import "../styles/style-portafolio-docente.css";
</style>
